const formatReal = (int) => {
  // Remove os centavos dividindo por 100 e pegando a parte inteira
  let valor = Math.floor(int / 100);
  return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const errorKit = (message) => {
  const errorBanner = document.createElement("div");
  errorBanner.classList.add("banner", "banner--error", "justify-center");
  errorBanner.setAttribute("role", "alert");
  errorBanner.style.gridColumn = "1/-1";
  errorBanner.style.marginBottom = "1rem";
  errorBanner.innerHTML = `
      <svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
        <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
        <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
      </svg>
      
      <p>${message}</p>
    `;
  document.querySelector(".kit-add-button").before(errorBanner);
  setTimeout(async () => {
    await errorBanner.animate(
      { opacity: [1, 0] },
      { duration: 250, fill: "forwards" }
    ).finished;
    errorBanner.remove();
  }, 5e3);
};

const calcKitPrice = () => {
  const kit_selectors = document.querySelectorAll(".product-kit-item");
  let kit_total_price = 0;
  if (kit_selectors.length > 0) {
    kit_selectors.forEach((kit_item, idx) => {
      const variant_selector = kit_item.querySelector(
        ".item-kit-change-variant"
      );
      const selected_variant =
        variant_selector.querySelector("option[selected]");
      const variant_price = Number(selected_variant.getAttribute("data-price"));
      const variant_compare_price = Number(
        selected_variant.getAttribute("data-compare-price")
      );
      kit_total_price += variant_price;
    });
  }
  const kit_price_element = document.querySelector(".kit-price");
  kit_price_element.innerHTML = `R$ ${formatReal(kit_total_price)}`;
};

const handleChangeRadio = (event) => {
  const label = event.target;
  const radio = label.previousElementSibling;
  const kit_id = radio.getAttribute("name").split("option")[0];
  const option_number = Number(radio.getAttribute("name").split("option")[1]);
  const item_element = document.querySelector(
    `.product-kit-item[data-kit-id="${kit_id}"]`
  );
  const options = {
    option1: "",
    option2: "",
    option3: "",
  };
  for (let i = 0; i < 3; i++) {
    let value = "";
    const item = item_element.querySelectorAll("[data-option-selector]")[i];
    if (item) {
      value = item.querySelector('input[type="radio"]:checked')
        ? item.querySelector('input[type="radio"]:checked').value
        : "";
    }
    if (i == option_number - 1) {
      value = radio.value;
    }
    options[`option${i + 1}`] = value;
    if (
      item_element.querySelector(`variant-option-value[for="option${i + 1}"]`)
    ) {
      item_element.querySelector(
        `variant-option-value[for="option${i + 1}"]`
      ).innerHTML = value;
    }
  }

  const next_item_button_kit = document.getElementById("next-slide-btn");

  const current_option = item_element.querySelector(
    `option[data-option1="${options.option1}"][data-option2="${options.option2}"][data-option3="${options.option3}"]`
  );
  if (current_option) {
    item_element.querySelector(".item-kit-change-variant").value =
      current_option.value;
    item_element
      .querySelector(".item-kit-change-variant")
      .dispatchEvent(new Event("change"));
    next_item_button_kit.removeAttribute("disabled");
  }

  //valita ativa ou nao botao
  const add_button_kit = document.querySelector(".kit-add-button");
  const qty_select = document.querySelectorAll(
    ".item-kit-change-variant"
  ).length;
  let qty_no_value = 0;
  document.querySelectorAll(".item-kit-change-variant").forEach((select) => {
    if (select.value == "") {
      qty_no_value++;
    }
  });
  if (qty_no_value > 0) {
    add_button_kit.setAttribute("disabled", true);
  } else {
    add_button_kit.removeAttribute("disabled");
    add_button_kit.classList.remove("hide");
    next_item_button_kit.classList.add("hide");
  }
};

const loadKitConfigs = () => {
  // calcKitPrice();
  // select.dispatchEvent(new Event('4'));
  var splide = new Splide(".splide");
  document
    .getElementById("next-slide-btn")
    .addEventListener("click", function () {
      splide.go("+1");
    });
  splide.mount();
  // const kit_selectors = document.querySelectorAll('.product-kit-item .item-kit-change-variant');
  // kit_selectors.forEach((select) => {
  //     select.dispatchEvent(new Event('change'));
  // })

  //deixa apenas primeira opçao marcada
  document
    .querySelectorAll('.product-kit-item input[type="radio"]')
    .forEach((radio, idx) => {
      radio.removeAttribute("checked");
    });
  document
    .querySelectorAll(".product-kit-item variant-option-value")
    .forEach((optionLabel, idx) => {
      optionLabel.innerHTML = "";
    });

  const labels_options = document.querySelectorAll(
    ".product-kit-item [data-option-value]"
  );
  if (labels_options.length > 0) {
    labels_options.forEach((label) => {
      label.addEventListener("click", (event) => {
        handleChangeRadio(event);
      });
    });
  }
};

const checkKitOptions = (option1, option2, option3, kit_id) => {
  const item_element = document.querySelector(
    `.product-kit-item[data-kit-id="${kit_id}"]`
  );
  const option2_options = item_element.querySelectorAll(
    `[name="${kit_id}option2"]`
  );
  if (option2_options.length > 0) {
    option2_options.forEach((opt) => {
      const value = opt.getAttribute("value");
      const select_opt = item_element.querySelector(
        `.item-kit-change-variant option[data-option1="${option1}"][data-option2="${value}"]`
      );
      const available =
        select_opt.getAttribute("data-available") === "true" ? true : false;
      const label_element = opt.nextElementSibling;
      if (available) {
        if (label_element.classList.contains("is-disabled")) {
          label_element.classList.remove("is-disabled");
        }
      } else {
        label_element.classList.add("is-disabled");
      }
    });
  }

  const option3_options = item_element.querySelectorAll(
    `[name="${kit_id}option3"]`
  );
  if (option3_options.length > 0) {
    option3_options.forEach((opt) => {
      const value = opt.getAttribute("value");
      const select_opt = item_element.querySelector(
        `.item-kit-change-variant option[data-option1="${option1}"][data-option2="${option2}"][data-option3="${value}"]`
      );
      const available =
        select_opt.getAttribute("data-available") === "true" ? true : false;
      const label_element = opt.nextElementSibling;
      if (available) {
        if (label_element.classList.contains("is-disabled")) {
          label_element.classList.remove("is-disabled");
        }
      } else {
        label_element.classList.add("is-disabled");
      }
    });
  }
};

const handleChangeVariant = (e, product_id) => {
  const variant_id = e.target.value;
  const item_element = document.querySelector(
    `.product-kit-item[data-kit-id="${product_id}"]`
  );
  const variant_id_element = item_element.querySelector('[name="id"]');
  const next_item_button_kit = document.getElementById("next-slide-btn");
  const disabled_button = document.querySelector(".kit-add-button-disabled");
  //altera value elemento que sera usado para post
  variant_id_element.setAttribute("value", variant_id);

  e.target.querySelectorAll("option").forEach((option) => {
    const option_variant_id = option.getAttribute("value");
    if (option_variant_id == e.target.value) {
      option.setAttribute("selected", true);
      const price = Number(option.getAttribute("data-price"));
      const compare_price = Number(option.getAttribute("data-compare-price"));
      const image_url = option.getAttribute("data-variant-image");
      const option1 = option.getAttribute("data-option1");
      const option2 = option.getAttribute("data-option2");
      const option3 = option.getAttribute("data-option3");
      const available =
        option.getAttribute("data-available") === "true" ? true : false;
      //altera imagem item
      const image_el = item_element.querySelector(".kit-image");
      image_el.setAttribute("src", image_url);
      image_el.setAttribute("srcset", image_url);

      //altera preco item
      item_element.querySelector(
        ".item-kit-price"
      ).innerHTML = `R$ ${formatReal(price)}`;
      item_element.querySelector(
        ".item-kit-compare-price"
      ).innerHTML = `R$ ${formatReal(compare_price)}`;
      if (compare_price > price) {
        item_element.querySelector(".item-kit-compare-price").style.display =
          "block";
      } else {
        item_element.querySelector(".item-kit-compare-price").style.display =
          "none";
      }

      //valida opcoes disables
      checkKitOptions(option1, option2, option3, product_id);
      if (available) {
        next_item_button_kit.classList.remove("hide");
        disabled_button.classList.add("hide");
      } else {
        next_item_button_kit.classList.add("hide");
        disabled_button.classList.remove("hide");
      }
    } else {
      option.removeAttribute("selected");
    }
  });
  calcKitPrice();
};

async function getCart() {
  const result = await fetch(window.Shopify.routes.root + "cart.js");

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(
    `Failed to get request, Shopify returned ${result.status} ${result.statusText}`
  );
}

const updateMiniCart = async (responseJson) => {
  const cart = await getCart();
  cart["sections"] = responseJson["sections"];

  document.dispatchEvent(
    new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items")
          ? responseJson["items"]
          : [responseJson],
        cart: cart,
      },
    })
  );
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        cart: cart,
      },
    })
  );
};

const addKitToCart = (kit_id) => {
  const add_button = document.querySelector(".kit-add-button");
  const kit_parent = document.querySelector(
    `[data-kit-product-id="${kit_id}"]`
  );
  const kit_name = kit_parent.getAttribute("data-kit-name");
  const sections = ["variant-added"];
  const sections_url = [];
  const formData = {
    items: [],
    sections: "",
    sections_url: "",
  };
  kit_parent.querySelectorAll(".product-kit-item").forEach((item) => {
    const item_id = Number(item.querySelector('[name="id"]').value);
    const item_qty = Number(item.querySelector('[name="quantity"]').value);
    formData.items.push({
      id: item_id,
      quantity: item_qty,
      properties: {
        Kit: kit_name,
      },
    });
    // sections.push(`sections--${item_id}__cart-drawer`);
    sections_url.push(`${Shopify.routes.root}variants/${item_id}`);
  });
  // formData.sections = sections.join(',');
  let sectionsToBundle = ["variant-added"];
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );
  formData.sections = sectionsToBundle.join(",");
  formData.sections_url = sections_url.join(",");
  add_button.setAttribute("disabled", true);
  if (formData.items.length > 0) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        add_button.removeAttribute("disabled");
        if (data.hasOwnProperty("items")) {
          updateMiniCart(data);
        } else {
          errorKit(
            data.description
              ? data.description
              : "Kit indisponível no momento confira o produtos selecionados e tente novamente"
          );
        }
      })
      .catch((error) => {
        add_button.removeAttribute("disabled");
        errorKit(
          "Kit indisponível no momento confira o produtos selecionados e tente novamente"
        );
      });
  }
};

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll(".product-kit-item--info").length > 0) {
    loadKitConfigs();
  }
});
